export const DEFAULT_ICON_SIZE = 27.83;
export const DEFAULT_TEXT_SIZE = 126.09;
export const DEFAULT_SPACING_SIZE = 8.08;
export const DEFAULT_LOGO_SIZE = 162;

export const ICON_TO_LOGO_RATIO = DEFAULT_ICON_SIZE / 162;
export const SPACING_TO_LOGO_RATIO = DEFAULT_SPACING_SIZE / 162;
export const TEXT_TO_LOGO_RATIO = DEFAULT_TEXT_SIZE / 162;
